export default __webpack_public_path__ + "static/media/blogImage3.9639a032.jpg";